export default __webpack_public_path__ + "static/media/stewart-connect-logo-white.2b3f0bfd.svg";